import { render, staticRenderFns } from "./PHome.vue?vue&type=template&id=febafeb0&"
import script from "./PHome.vue?vue&type=script&lang=js&"
export * from "./PHome.vue?vue&type=script&lang=js&"
import style0 from "./PHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports